import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { EN, ES } from "./language-support";

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  // language resources
  resources: {
    en: {
      translation: EN,
    },
    es: {
      translation: ES,
    },
  },
});

export default i18n;
